module.exports = __webpack_public_path__ + "static/media/downloadIcon.dddfbcb0.svg";